(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import cx from "classnames";
import { useTranslation } from "react-i18next";
import { BackButtonContainer } from "../../../BrowserHistory";
import Loading from "../../../../components/Loading";
import Badge from "../../../../components/Badge";
import CodeDetails from "../CodeDetails";
import DownloadButton from "../../../../components/DownloadButton";
import Tabs from "../../../../components/Tabs";
import styles from "./SearchDetails.module.css";
import SearchDetailsPaginate from "../SearchDetailsPaginate";
import ExplanatoryNotesContainer from "../../containers/ExplanatoryNotesContainer";

const SearchDetails = _ref => {
  var _hsCodeLevel6$childre;

  let {
    hsCodeLevel2,
    hsCodeLevel4,
    hsCodeLevel6,
    searchCode,
    isLoading,
    basicUrl,
    colors,
    isRtl,
    onApplyCode,
    onDownload,
    onBackAction
  } = _ref;
  const location = useLocation();
  const {
    t
  } = useTranslation();
  const hasError = useMemo(() => hsCodeLevel2 && hsCodeLevel2.hasError || hsCodeLevel4 && hsCodeLevel4.hasError || hsCodeLevel6 && hsCodeLevel6.hasError, [hsCodeLevel2, hsCodeLevel4, hsCodeLevel6]); // remove chapter from defaultBackUrl

  const search = useMemo(() => location.search.replace(/(&chapter=)[^/&]+/, ""), [location.search]);
  const downloadOptions = useMemo(() => [{
    label: t("Chapter data"),
    value: "ChapterData"
  }, {
    label: t("Complete tariff book"),
    value: "TariffBook"
  }], [t]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BackButtonContainer, {
    defaultBackUrl: "".concat(basicUrl || "", "/search").concat(search),
    onClick: onBackAction,
    className: styles.backBtn
  }), /*#__PURE__*/React.createElement(Tabs, {
    className: styles.details
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement(Tabs.TabList, null, /*#__PURE__*/React.createElement(Tabs.Tab, null, /*#__PURE__*/React.createElement("div", {
    className: styles.rootHsCode,
    style: {
      borderColor: colors.success
    }
  }, searchCode)), /*#__PURE__*/React.createElement(Tabs.Tab, {
    className: styles.notes
  }, t("Explanatory notes")))), /*#__PURE__*/React.createElement(Tabs.TabPanel, {
    className: cx(styles.detailsContainer, {
      [styles.rtl]: isRtl
    })
  }, isLoading ? /*#__PURE__*/React.createElement("div", {
    className: styles.center
  }, /*#__PURE__*/React.createElement(Loading, {
    color: colors.success
  })) : hasError ? /*#__PURE__*/React.createElement("div", {
    className: styles.center
  }, t("The HS code you are trying to view does not exist. Please run another search using the bar above.")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("ul", {
    className: styles.codes
  }, /*#__PURE__*/React.createElement("li", {
    className: styles.code
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.codeLabel
  }, t("CHAPTER")), /*#__PURE__*/React.createElement("div", {
    className: styles.codeDesc
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.badge
  }, /*#__PURE__*/React.createElement(Badge, {
    color: colors.secondary
  }, hsCodeLevel2.code)), /*#__PURE__*/React.createElement("div", {
    className: cx(styles.codeDescTitle, {
      [styles.rtl]: isRtl
    })
  }, hsCodeLevel2.description))), hsCodeLevel4.code ? /*#__PURE__*/React.createElement("li", {
    className: styles.code
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.codeLabel
  }, t("HEADING")), /*#__PURE__*/React.createElement("div", {
    className: styles.codeDesc
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.badge
  }, /*#__PURE__*/React.createElement(Badge, {
    color: colors.secondary
  }, hsCodeLevel4.code)), /*#__PURE__*/React.createElement("div", {
    className: cx(styles.codeDescTitle, {
      [styles.rtl]: isRtl
    })
  }, hsCodeLevel4.description))) : null, /*#__PURE__*/React.createElement("li", {
    className: styles.code,
    id: "se-hs-code-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.codeLabel
  }, t("HS CODE")), hsCodeLevel6 && /*#__PURE__*/React.createElement("div", {
    className: styles.codeDesc
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.badge
  }, /*#__PURE__*/React.createElement(Badge, {
    color: colors.success
  }, hsCodeLevel6.code)), /*#__PURE__*/React.createElement("div", {
    className: cx(styles.codeDescTitle, {
      [styles.rtl]: isRtl
    })
  }, hsCodeLevel6.description)))), hsCodeLevel6.children ? (_hsCodeLevel6$childre = hsCodeLevel6.children) === null || _hsCodeLevel6$childre === void 0 ? void 0 : _hsCodeLevel6$childre.map((child, index) => /*#__PURE__*/React.createElement(CodeDetails, {
    details: child,
    isRtl: isRtl,
    onApplyCode: onApplyCode,
    key: "".concat(child.code, "-").concat(child.description),
    colors: colors,
    taxes: hsCodeLevel6.taxes,
    isFirstItem: index === 0,
    isNextItemHasChildren: hsCodeLevel6.children[index + 1] && hsCodeLevel6.children[index + 1].children,
    isPreviousItemHasChildren: hsCodeLevel6.children[index - 1] && hsCodeLevel6.children[index - 1].children
  })) : /*#__PURE__*/React.createElement(CodeDetails, {
    details: hsCodeLevel6,
    onApplyCode: onApplyCode,
    isRtl: isRtl,
    key: "".concat(hsCodeLevel6.code, "-").concat(hsCodeLevel6.description),
    colors: colors,
    taxes: hsCodeLevel6.taxes,
    isFirstItem: true,
    isNextItemHasChildren: false,
    isPreviousItemHasChildren: false
  }))), /*#__PURE__*/React.createElement(Tabs.TabPanel, {
    className: cx(styles.detailsContainer, styles.notes)
  }, /*#__PURE__*/React.createElement(ExplanatoryNotesContainer, null))), !hasError && hsCodeLevel2 && /*#__PURE__*/React.createElement(SearchDetailsPaginate, null));
};

__signature__(SearchDetails, "useLocation{location}\nuseTranslation{{ t }}\nuseMemo{hasError}\nuseMemo{search}\nuseMemo{downloadOptions}", () => [useLocation, useTranslation]);

SearchDetails.propTypes = {
  hsCodeLevel2: PropTypes.object,
  hsCodeLevel4: PropTypes.object,
  hsCodeLevel6: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  searchCode: PropTypes.string.isRequired,
  basicUrl: PropTypes.string,
  colors: PropTypes.shape({
    info: PropTypes.string,
    success: PropTypes.string,
    secondary: PropTypes.string
  }).isRequired,
  isRtl: PropTypes.bool,
  onApplyCode: PropTypes.func,
  onDownload: PropTypes.func.isRequired,
  onBackAction: PropTypes.func
};
SearchDetails.defaultProps = {
  hsCodeLevel2: null,
  hsCodeLevel4: null,
  hsCodeLevel6: null,
  basicUrl: null,
  onApplyCode: null,
  isRtl: false,
  onBackAction: null
};

const _default = /*#__PURE__*/React.memo(SearchDetails);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(SearchDetails, "SearchDetails", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/components/SearchDetails/SearchDetails.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/components/SearchDetails/SearchDetails.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();